// The Main List counts every WildCard place, whether or not a player holds it yet (Tudor, 2026-10-18): a reserved place is no
// longer open to a standard entry. Five standard players and one WC place still to assign read "6 / 6 ML · incl. 0/1 WC".
const count = value => Number.isFinite(value) && value >= 0 ? value : null

// `entries`: confirmed Main List entries, WildCards included; `occupied`: those on a WC place; `reserved`: the WC places.
// `open` is the reserved places no player holds yet; when the WC places cannot be read, the entries still count.
export const mainListPlaces = ({ entries, occupied, reserved }) => {
  const [main, used, wildCards] = [entries, occupied, reserved].map(count)
  const open = used === null || wildCards === null ? null : Math.max(0, wildCards - used)
  return { taken: main === null ? null : main + (open ?? 0), open, occupied: used, reserved: wildCards }
}

// A competition row of the event reads (directory, event details, events list).
export const competitionPlaces = competition => mainListPlaces({ entries: competition?.mainListCount, occupied: competition?.wildCardCount,
  reserved: competition?.wildCards })

// The event totals (Events' entryTotals) plus its open WC places. Those add each competition's own when the read lists them, so a WC
// held beyond its reservation never hides another competition's open place; otherwise they come from the totals.
export const eventPlaces = (totals, competitions) => {
  const event = mainListPlaces({ entries: totals?.mainList, occupied: totals?.wildCards, reserved: totals?.wildCardCapacity })
  const rows = Array.isArray(competitions) && competitions.length ? competitions.map(competitionPlaces) : []
  const open = rows.length && rows.every(row => row.open !== null) ? rows.reduce((total, row) => total + row.open, 0) : event.open
  const entries = count(totals?.mainList)
  return { ...event, open, taken: entries === null ? null : entries + (open ?? 0) }
}
